import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateCredentials, systemInfo, getAdminUser } from './temporaryAuthData';
import './LoginScreen.css';

const LoginScreen = ({ onLogin }) => {
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [shakeError, setShakeError] = useState(false);
    const navigate = useNavigate();

    // Автозаполнение для демонстрации
    useEffect(() => {
        const savedUsername = localStorage.getItem('lg_savedUsername');
        if (savedUsername) {
            setFormData(prev => ({ ...prev, username: savedUsername }));
        }
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (error) setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setShakeError(false);

        // Валидация
        if (!formData.username.trim() || !formData.password.trim()) {
            setError('Заполните все поля');
            setShakeError(true);
            return;
        }

        setLoading(true);

        try {
            // Имитация задержки сети
            await new Promise(resolve => setTimeout(resolve, 500));

            // Проверка учетных данных
            const isValid = validateCredentials(formData.username, formData.password);

            if (isValid) {
                const user = getAdminUser();

                // Сохраняем данные пользователя
                localStorage.setItem('lg_userRole', user.role);
                localStorage.setItem('lg_username', user.username);
                localStorage.setItem('lg_userName', user.name);
                localStorage.setItem('lg_userEmail', user.email);
                localStorage.setItem('lg_userDepartment', user.department);
                localStorage.setItem('lg_userPermissions', JSON.stringify(user.permissions));
                localStorage.setItem('lg_savedUsername', user.username);
                localStorage.setItem('lg_lastLogin', new Date().toISOString());

                // Передаем данные в родительский компонент
                onLogin(user);

                // Анимация успешного входа
                document.querySelector('.lg-login-container')?.classList.add('lg-success-animation');

                // Задержка перед переходом
                setTimeout(() => {
                    navigate('/app');
                }, 400);
            } else {
                setError('Неверный логин или пароль');
                setShakeError(true);
                setLoading(false);
            }
        } catch (err) {
            console.error('Ошибка при входе:', err);
            setError('Произошла ошибка при входе. Попробуйте позже.');
            setShakeError(true);
            setLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit(e);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    // Автозаполнение тестовых данных
    const fillTestCredentials = () => {
        setFormData({
            username: 'admin',
            password: 'admin123'
        });
        setError('');
        setShakeError(false);
    };

    return (
        <div className="lg-login-page">
            <div className="lg-login-container">
                <div className="lg-login-header">
                    <div className="lg-logo">
                        <div className="lg-logo-icon">⚡</div>
                        <div className="lg-system-info">
                            <h1 className="lg-system-name">{systemInfo.name}</h1>
                            <p className="lg-system-fullname">{systemInfo.fullName}</p>
                        </div>
                    </div>
                    <p className="lg-subtitle">Авторизация в системе мониторинга</p>
                </div>

                <form onSubmit={handleSubmit} className="lg-login-form">
                    <div className="lg-input-group">
                        <label htmlFor="lg-username" className="lg-input-label">
                            Имя пользователя
                        </label>
                        <div className="lg-input-wrapper">
                            <span className="lg-input-icon">👤</span>
                            <input
                                id="lg-username"
                                name="username"
                                type="text"
                                placeholder="admin"
                                value={formData.username}
                                onChange={handleInputChange}
                                onKeyPress={handleKeyPress}
                                disabled={loading}
                                autoComplete="username"
                                className="lg-input-field"
                            />
                        </div>
                    </div>

                    <div className="lg-input-group">
                        <label htmlFor="lg-password" className="lg-input-label">
                            Пароль
                        </label>
                        <div className="lg-input-wrapper">
                            <span className="lg-input-icon">🔒</span>
                            <input
                                id="lg-password"
                                name="password"
                                type={showPassword ? "text" : "password"}
                                placeholder="admin123"
                                value={formData.password}
                                onChange={handleInputChange}
                                onKeyPress={handleKeyPress}
                                disabled={loading}
                                autoComplete="current-password"
                                className="lg-input-field"
                            />
                            <button
                                type="button"
                                className="lg-password-toggle"
                                onClick={togglePasswordVisibility}
                                tabIndex="-1"
                            >
                                {showPassword ? '🙈' : '👁️'}
                            </button>
                        </div>
                        <div className="lg-test-credentials">
                            <button
                                type="button"
                                className="lg-test-button"
                                onClick={fillTestCredentials}
                            >
                                <span className="lg-test-icon">🔑</span>
                                <span>Заполнить тестовые данные</span>
                            </button>
                        </div>
                    </div>

                    <div className="lg-form-options">
                        <label className="lg-checkbox-label">
                            <input
                                type="checkbox"
                                className="lg-checkbox"
                                defaultChecked
                            />
                            <span className="lg-checkbox-text">Запомнить пользователя</span>
                        </label>
                        <div className="lg-credentials-hint">
                            <span>Логин: admin / Пароль: admin123</span>
                        </div>
                    </div>

                    <button
                        type="submit"
                        className={`lg-login-button ${loading ? 'lg-loading' : ''}`}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="lg-spinner"></span>
                                <span className="lg-button-text">Вход...</span>
                            </>
                        ) : (
                            <>
                                <span className="lg-button-icon">🚀</span>
                                <span className="lg-button-text">Войти в систему</span>
                            </>
                        )}
                    </button>

                    {error && (
                        <div className={`lg-error-message ${shakeError ? 'lg-shake' : ''}`}>
                            <span className="lg-error-icon">⚠️</span>
                            <span className="lg-error-text">{error}</span>
                        </div>
                    )}
                </form>

                <div className="lg-login-footer">
                    <div className="lg-system-version">
                        <span className="lg-version-text">MAS-IOT v{systemInfo.version}</span>
                        <span className="lg-separator">•</span>
                        <span className="lg-auth-type">Только административный доступ</span>
                    </div>
                </div>
            </div>

            {/* Минимальные декоративные элементы */}
            <div className="lg-decoration-circle lg-circle-1"></div>
            <div className="lg-decoration-circle lg-circle-2"></div>
        </div>
    );
};

export default LoginScreen;